import {makeAutoObservable} from "mobx";
import Store from "./Store";

export default class MobileUserStore {
  linkedServices: string[] = [];
  
  constructor(store: Store) {
    makeAutoObservable(this);
  }
  
  setLinkedServices(linkedServices: string[]): boolean {
    const current = this.linkedServices;
    const newSet = new Set(linkedServices);
    const oldSet = new Set(current);
    
    const toAdd = linkedServices.filter(s => !oldSet.has(s));
    const toRemove = current.filter(s => !newSet.has(s));
    
    if (toAdd.length === 0 && toRemove.length === 0) {
      return false;
    }

    this.linkedServices.splice(0, current.length, ...linkedServices);
    return true;
  }
}